<p-confirmDialog key="username" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div>
	<p>Enter your email address and if you have an account your username will be sent to you.</p>
</div>

<!--Enter Email-->
<div class="TopMargin">
	<input type="text" class="form-control" [(ngModel)]="Email" placeholder="Example@Example.com" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="loading == true" class="btn btn-primary" (click)="onSendUsername()">Send Username</button>
	<button [disabled]="loading == true" class="btn btn-primary" (click)="onCancel()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
